var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTemperatureSymbol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#455063;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-1",
    d: "M428.82,131.74V151H354.3V131.74Zm-31.26,41.91H354.25v19.23h43.31ZM354.25,234.8h74.52V215.57H354.3Zm43.31,22.71H354.25v19.22h43.31Zm-43.31,61.14h74.52V299.41H354.3Zm11.66,109.57a97.37,97.37,0,1,1-146.61-83.9V123.61a49.28,49.28,0,0,1,98.56,0V344.32a96.87,96.87,0,0,1,48.08,83.9Zm-19.23,0a77.76,77.76,0,0,0-42.82-69.6l-5.26-2.69V123.61a30,30,0,1,0-60.09,0h0V355.88l-5.27,2.69a78.1,78.1,0,1,0,113.44,69.6Zm-16,0a62.11,62.11,0,1,1-78.08-60l3.56-.95V248.73H281v118.6l3.57.95a62.1,62.1,0,0,1,46.11,60Zm-59-41.4a12.43,12.43,0,0,0-14.85-9.36,51.06,51.06,0,0,0-40,50.08,12.41,12.41,0,0,0,24.81,0,26.64,26.64,0,0,1,20.64-25.87,12.47,12.47,0,0,0,9.36-14.85Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperatureSymbol);
export default __webpack_public_path__ + "static/media/temperature-symbol.7e4ec27e717286d197d06b56acd4ff7e.svg";
export { ForwardRef as ReactComponent };